import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import MenuA from './components/Menu__a/Menu';
import MenuB from './components/Menu__b/Menu';
import ReviewOrderButtonContainer from '../ReviewOrderButton/ReviewOrderButtonContainer';
import spinner from '../../assets/spinner.svg';
import { AppConfigContext } from '../../layout/Layout';
import { getProductToConfigure } from '../ProductCustomizer/productCustomizerActions';
import { getCombo } from './../Combo/comboActions';
import OrderSettingSummaryContainer from '../OrderSetting/OrderSettingSummary/OrderSettingSummaryContainer';
import * as queryString from 'query-string';
import appConfig from '../../../app-config';
import { DELIVERY } from '../OrderSetting/orderSettingTypes';
import useCart from '../../customHooks/useCart';
import { validateGlobalCart, updateCartScreen } from '../Cart/cartActions';

const MenuWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 32px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 786px) {
    margin-top: -50px;
    display: block;
    margin-top: 12px;
  }
`;

const OrderSettingSummaryContainerWrapper = styled.div`
  margin-top: -50px;
  padding: 34px 20px 20px 0;
  @media (min-width: 1101px) {
    display: none;
  }
  @media (max-width: 1101px) {
    margin-top: 0px;
  }
`;

const MenuContainer = ({
  menuReducer,
  combos,
  orderHistory,
  favouritesList,
  isAuthenticated,
  getProductToConfigure,
  getCombo,
  selectedPickUpLocation,
  orderSettingReducer,
  location,
  currentLocation,
  selectedChildLocation,
  locations,
  globalCart,
  validateGlobalCart,
  updateCartScreen,
}) => {
  const { categories, products, requestingGetMenu } = menuReducer;
  const { interOrderType, interSelectedDateTime } = orderSettingReducer;

  if (orderHistory && orderHistory.length) {
    orderHistory = orderHistory.filter((order) => order.config_products.length);
  }
  const [pathname, setPathname] = useState('/menu/');
  const [filter, setFilter] = useState({
    products: null,
    categories: null,
    combos: [],
  });

  const searchProducts = (productName) => {
    if (productName !== '') {
      const filteredProducts = products.filter((product) =>
        product.name.includes(productName)
      );

      const productIds = filteredProducts.map((product) => product.product_id);

      const filteredCategories = categories.filter((categorie) =>
        categorie.products.some((product) =>
          productIds.includes(product.product_id)
        )
      );

      const filteredCombos = combos.filter((combo) =>
        combo.name.includes(productName)
      );

      if (filteredProducts.length > 0) {
        if (filteredCombos.length > 0) {
          filteredCategories.push({
            name: 'Combos',
            category_id: 998,
            parent_id: null,
            position: 1,
            tag: '',
            image_url: '',
            products: [],
          });
        }

        setFilter({
          ...filter,
          products: filteredProducts,
          categories: filteredCategories,
          combos: filteredCombos,
        });
      }
    } else {
      setFilter({
        ...filter,
        products: null,
        categories: null,
        combos: [],
      });
    }
  };

  let updatedCategories = [];
  if (isAuthenticated) {
    let sub_categories = [];

    if (orderHistory.length) {
      sub_categories.push({
        category_id: 1001,
        parent_id: 999,
        name: 'My Orders',
        position: 3,
        tag: '',
        image_url: '',
        sub_categories: [],
        products: [],
      });
    }

    if (favouritesList.length) {
      sub_categories.push({
        category_id: 1000,
        parent_id: 999,
        name: 'My Favourites',
        position: 2,
        tag: '',
        image_url: '',
        sub_categories: [],
        products: [],
      });
    }
    if (sub_categories.length)
      updatedCategories = [
        {
          name: 'My Orders',
          category_id: 999,
          parent_id: null,
          position: 1,
          tag: '',
          image_url: '',
          products: [],
          sub_categories,
        },
      ];
  }

  if (combos && combos.length > 0) {
    updatedCategories.push({
      name: 'Combos',
      category_id: 998,
      parent_id: null,
      position: 1,
      tag: '',
      image_url: '',
      products: [],
    });
  }

  updatedCategories = [...updatedCategories, ...(categories || [])];

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      pathname !== window.location.pathname
    ) {
      setPathname(window.location.pathname);
    }
  });

  const handleProductPreviewClick = (productId, product) => {
    getProductToConfigure(productId, null, null, product.variant_id);
  };

  const handleComboPreviewClick = (comboId) => {
    // setPathname(`/menu/${productId}`);
    // window.history.pushState(null, '', `/menu/${productId}`);

    if (interOrderType === DELIVERY) {
      const deliveryLocation =
        orderSettingReducer.interDeliveryDetails.deliveryBusiness.id;
      getCombo(comboId, deliveryLocation);
    } else if (selectedPickUpLocation) {
      getCombo(comboId, selectedPickUpLocation.id);
    }
  };

  const navigateToMenu = () => {
    setPathname(`/menu/`);
    window.history.pushState(null, '', `/menu/`);
  };

  const productId = pathname === '/menu/' ? null : pathname.substring(6);

  const renderMenu = (appConfig) => {
    switch (appConfig.styleConfig.menuStyle) {
      case 'styleA':
        return (
          <MenuA
            categories={updatedCategories}
            products={products}
            combos={combos}
            handleProductPreviewClick={handleProductPreviewClick}
            handleComboPreviewClick={handleComboPreviewClick}
            dontSelectMyOrders={!orderHistory.length && isAuthenticated}
          />
        );
      case 'styleB':
        return (
          <MenuB
            categories={
              filter.categories ? filter.categories : updatedCategories
            }
            products={filter.products ? filter.products : products}
            combos={filter.combos.length > 0 ? filter.combos : combos}
            handleProductPreviewClick={handleProductPreviewClick}
            handleComboPreviewClick={handleComboPreviewClick}
            dontSelectMyOrders={!orderHistory.length && isAuthenticated}
            orderSettingReducer={orderSettingReducer}
            searchProduct={(product) => searchProducts(product)}
          />
        );
    }
  };

  if (
    (!orderSettingReducer.selectedLocation &&
      !orderSettingReducer.interPickUpDetails &&
      !orderSettingReducer.interDeliveryDetails &&
      !orderSettingReducer.interDropOffDetails) ||
    !menuReducer.products ||
    !locations.length
  ) {
    return null;
  }
  return (
    <AppConfigContext.Consumer>
      {(appConfig) => (
        <div>
          <OrderSettingSummaryContainerWrapper>
            <OrderSettingSummaryContainer />
          </OrderSettingSummaryContainerWrapper>
          <MenuWrapper>
            <div>
              {!requestingGetMenu ? (
                renderMenu(appConfig)
              ) : (
                <div style={{ textAlign: 'center', marginTop: '160px' }}>
                  <img src={spinner} style={{ width: '100px' }} />
                </div>
              )}
              <ReviewOrderButtonContainer updateCartScreen={updateCartScreen} />
            </div>
          </MenuWrapper>
        </div>
      )}
    </AppConfigContext.Consumer>
  );
};

const mapStateToProps = (state) => ({
  menuReducer: state.menuReducer,
  combos: state.comboReducer.combos,
  orderHistory: state.orderHistoryReducer.orderHistory,
  favouritesList: state.favouritesReducer.favouritesList,
  isAuthenticated: state.authReducer.isAuthenticated,
  selectedPickUpLocation: state.orderSettingReducer.interPickUpDetails,
  orderSettingReducer: state.orderSettingReducer,
  currentLocation: state.orderConfigReducer,
  selectedChildLocation: state.orderSettingReducer.selectedChild,
  locations: state.locationsReducer.locations,
  globalCart: state.cartReducer.cart, //GLOBAL CART
});

const actions = { getProductToConfigure, getCombo };

export default connect(mapStateToProps, {
  ...actions,
  validateGlobalCart,
  updateCartScreen,
})(MenuContainer);
